"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const GroupedDocumentUploadTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/GroupedDocumentUploadTable"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const EditUploadedDocumentsForm_1 = __importDefault(require("@Components/OverclaimView/DocumentForms/EditUploadedDocumentsForm"));
const DisputeOptionItem_1 = __importDefault(require("@Components/OverclaimView/DisputeOptionSection/DisputeOptionItem"));
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const OverclaimDocumentTab = ({ onClickUploadDocumentsOption }) => {
    const { overclaimViewStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [overclaimDocumentToEdit, setOverclaimDocumentToEdit] = (0, react_1.useState)(null);
    const state = (0, react_router_dom_1.useLocation)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setLoading(true);
        overclaimViewStore.loadOverclaimDocumentsForCurrentOverclaimViewItem().finally(() => setLoading(false));
    }, [state]);
    const editDocumentFormIsOpened = overclaimDocumentToEdit !== null;
    const openEditDocumentForm = (document) => {
        setOverclaimDocumentToEdit(document);
    };
    const closeEditDocumentForm = () => {
        setOverclaimDocumentToEdit(null);
    };
    return (react_1.default.createElement("div", { id: 'detail-tab' },
        loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(GroupedDocumentUploadTable_1.default, { onValidation: () => { }, onAddDescriptionToDocumentClicked: (document) => openEditDocumentForm(document) }),
            react_1.default.createElement("div", { className: 'overclaim-item-bottom-section' },
                react_1.default.createElement(DisputeOptionItem_1.default, { title: 'Upload Documents', body: 'Upload documents on this work to support your claim on this work.', onClick: onClickUploadDocumentsOption, buttonText: 'Upload Documents' })))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: editDocumentFormIsOpened },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: () => {
                    closeEditDocumentForm();
                } }, overclaimDocumentToEdit && (react_1.default.createElement(EditUploadedDocumentsForm_1.default, { overlaimUploadedDocument: overclaimDocumentToEdit, onSaveClicked: closeEditDocumentForm }))))));
};
exports.default = OverclaimDocumentTab;
